import type { MemoExoticComponent, JSX } from "react"
import { memo } from "react"
import { createPortal } from "react-dom"
import type { ModalType } from "./ModalContext"
import { ModalRenderer } from "./ModalRenderer"

interface ModalContainerProps {
	/**
	 * Map of modal instances associated by unique ids
	 */
	modals: Record<string, ModalType<any>>

	/**
	 * Root component for modals. Defaults to document.body
	 */
	root?: Element
}

export const ModalContainer: MemoExoticComponent<(props: ModalContainerProps) => JSX.Element> = memo(
	(props: ModalContainerProps) => {
		const { modals, root = document.body } = props

		return createPortal(
			// biome-ignore lint/complexity/noUselessFragments: Portal expects a single element.
			<>
				{Object.keys(modals).map((id) => {
					const { component, props: modalProps } = modals[id]
					return <ModalRenderer key={id} props={{ id, modalProps }} component={component} />
				})}
			</>,
			root,
		)
	},
)

ModalContainer.displayName = "ModalContainer"
